import { Auth } from 'aws-amplify'

/** Cognito sub (username) for server-side price audit resolution. */
export const getPriceChangeActor = async () => {
  const session = await Auth.currentAuthenticatedUser()
  return session?.attributes?.sub || 'unknown'
}
